import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as uuid from 'uuid';
import { ScannedProductDetailsResponseBO } from '../qr-product-scan/scannedProductDetailsResponseBO';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DataService {

  qrCode: any;
  errorMessage: any;
  errorDescription: any;
  languageISO: any = 'en';
  ipAddress: any;
  languages: any;

  displayLangSelPopup = new BehaviorSubject<boolean>(false)
  displayLangSelPopupObs = this.displayLangSelPopup.asObservable();

  defaultSelectedLanguage = new BehaviorSubject<String>('English');
  defaultSelectedLanguageObs = this.defaultSelectedLanguage.asObservable()

  languageChange = new BehaviorSubject<boolean>(false);
  languageChangeObs = this.languageChange.asObservable();

  constructor(private httpClient: HttpClient, public router: Router) {
    this.languages = [
      { languageId: 1, name: 'English', iso6391: 'en' },
      { languageId: 2, name: 'हिंदी', iso6391: 'hi' },
      { languageId: 3, name: 'ಕನ್ನಡ', iso6391: 'kn' },
      { languageId: 4, name: 'मराठी', iso6391: 'mr' },
      { languageId: 5, name: 'తెలుగు', iso6391: 'te' },
      { languageId: 6, name: 'ગુજરાતી', iso6391: 'gu' },
      { languageId: 7, name: 'ଓଡିଆ', iso6391: 'or' },
      { languageId: 8, name: 'ਪੰਜਾਬੀ', iso6391: 'pa' },
      { languageId: 9, name: 'বাংলা', iso6391: 'bn' },
      { languageId: 10, name: 'தமிழ்', iso6391: 'ta' }
    ]
   }

  //POST API => validate QR product scan
  public validateProduct(languageISO: string, scanTime: string, ipAddress: any) {
    let authorization = 'Basic ' + btoa(environment.username + ":" + environment.password)
    const headers = {
      requestId: uuid.v4(),
      languageISO: languageISO,
      'countryISOCode': 'IN',
      'Authorization': authorization
    };
    const body = { code_or_url: this.qrCode, scan_platform: 'public', scan_time: scanTime, ip_address: ipAddress };
    return this.httpClient.post<ScannedProductDetailsResponseBO>(environment.API_BASE_URL, body, { headers })
  }

  //set qr code or url of the product
  public setQRCode(qrCode: string) {
    this.qrCode = qrCode;
  }

  setErrorMessage(errorMessage: any) {
    this.errorMessage = errorMessage;
  }

  getErrorMessage() {
    return this.errorMessage;
  }

  setErrorDescription(errorDescription: any) {
    this.errorDescription = errorDescription;
  }

  getErrorDescription() {
    return this.errorDescription;
  }

  setLanguageISO(languageISO: any) {
    this.languageISO = languageISO;
  }

  getLanguageISO() {
    return this.languageISO;
  }

  setIPApddress(ipAddress: any) {
    this.ipAddress = ipAddress;
  }

  getIPApddress() {
    return this.ipAddress;
  }
}
